import type { JobCardProps } from '@/components/job-card'
import type { SavedOpportunity } from '@/hooks/use-saved-opportunities'
import { MARKETPLACE_INSIGHT_CAPTION } from '@/lib/candidate-match-bands'
import { normalizeMatchBand } from '@/lib/match-bands'

export function buildSavedOpportunityFitProps(
  opportunity: SavedOpportunity,
  options: {
    pending: boolean
    stuck?: boolean
    onRetry?: () => void
    retryPending?: boolean
  },
): Pick<JobCardProps, 'matchBand' | 'matchBandCaption' | 'fitInsight'> {
  if (options.stuck) {
    return {
      fitInsight: {
        highlights: [],
        redFlags: [],
        stuck: true,
        onRetry: options.onRetry,
        retryPending: options.retryPending,
        variant: 'compact',
      },
    }
  }

  if (options.pending) {
    return { fitInsight: { highlights: [], redFlags: [], pending: true, variant: 'compact' } }
  }

  const insight = opportunity.insight
  if (!insight) {
    return {
      fitInsight: {
        highlights: [],
        redFlags: [],
        notAnalysed: true,
        onRetry: options.onRetry,
        retryPending: options.retryPending,
        variant: 'compact',
      },
    }
  }

  const band = normalizeMatchBand(insight.band)

  return {
    matchBand: band,
    fitInsight: {
      highlights: insight.highlights,
      redFlags: insight.red_flags,
      recommendation: insight.recommendation,
      caption:
        insight.source === 'listing_description' ? MARKETPLACE_INSIGHT_CAPTION : undefined,
      variant: 'compact',
    },
  }
}
